import { BUILDING_LOCKED_TOOLTIP_POSITION } from '@/map-phaser-new/constants'
import type { BuildingConfigInterface } from '@/map-phaser-new/interfaces'

export const tournamentsConfig: BuildingConfigInterface = {
  textureKey: 'buildings',
  frameKey: 'tournaments',
  routeConfig: {
    routeName: 'TournamentsCalendar',
    soundName: 'click-map-artefact',
    isRouteParamIdNeeded: false,
  },
  positionX: 2224,
  positionY: 1345,
  depth: 4,
  originX: 0,
  keyForTranslateTitle: 'map.tournamentsName',
  buildingTitleConfig: {
    positionX: 2416,
    positionY: 1603,
    depth: 7,
    textConfig: {
      originX: 0.5,
      fontName: 'Roboto Condensed',
      fontSize: '24px',
      fontWeight: 'normal',
      fontStyle: 'italic',
      fontColor: '#fff',
    },
    backgroundImageConfig: {
      textureName: 'common',
      frameNameRightSide: 'right_side',
      frameNameRightSideLocked: 'right_side_locked',
      originX: 0.5,
      widthCorrection: 100,
      heightCorrection: 10,
    },
  },
  outlineConfig: {
    framePostFix: '_outline',
    depth: 6,
    originX: 0,
    positionByLevel: {
      '1': { positionX: 2224, positionY: 1345 },
    },
    textureKey: 'buildingsOutlines',
  },
  inputConfig: {
    useHandCursor: true,
  },
  buildingLockedConfig: {
    textureKey: 'lockedBuildings',
    framePostfix: '_locked',
    lockImageTextureKey: 'lock',
    positionX: 2408.5,
    positionY: 1450,
    lockImageDepth: 6,
    depth: 5,
    tooltipConfig: {
      tooltipPosition: BUILDING_LOCKED_TOOLTIP_POSITION.Top,
      tooltipTextureHeight: '213px',
      tooltipTextureWidth: '444px',
      depth: 10,
      titleConfig: {
        originX: 0.5,
        fontSize: '30px',
        fontName: 'Roboto Condensed',
        fontWeight: '600',
        fontStyle: 'italic',
        fontColor: '#fff',
      },
      subtitleConfig: {
        originX: 0.5,
        originY: 0.5,
        fontName: 'Roboto Condensed',
        fontSize: '24px',
        fontWeight: 'normal',
        fontStyle: 'italic',
        fontColor: '#fff',
        replaceFontColor: '#fec742',
        tooltipSubtitleTranslateKey: 'common.mainCareerTaskRequired',
        tooltipSubtitleReplaceFlag: '%s',
      },
      tooltipHideDelay: 2000,
      tooltipLeftTextureName: 'building_tooltip_left',
      tooltipRightTextureName: 'building_tooltip_right',
      tooltipTopTextureName: 'building_tooltip_top',
      tooltipTextureSponsoredHeight: '357px',
      tooltipTextureSponsoredWidth: '604px',
      tooltipTopTextureSponsoredName: 'building_tooltip_sponsored_top',
      sponsoredTitleConfig: {
        fontName: 'Roboto Condensed',
        fontSize: '32px',
        fontWeight: 'normal',
        fontStyle: 'italic',
        fontColor: '#d9ecff',
      },
      sponsorLogoSize: '92px',
      sponsorGoalTextKey: 'tournaments.beatTime',
      sponsorGoalTextReplaceFlag: '{time}',
      sponsorTitleTextKey: 'tournaments.earlyAccess',
    },
  },
}
